import { useEffect, useState } from "react";

/** Default breakpoint at which the layout switches from mobile/portrait to desktop/landscape. */
export const WIDE_BREAKPOINT_PX = 900;

/**
 * Returns true when the viewport is at least `breakpoint` pixels wide.
 * Updates reactively on window resize so layout flips when the device is rotated
 * or a window is dragged across the breakpoint.
 */
export function useIsWide(breakpoint = WIDE_BREAKPOINT_PX): boolean {
  const [wide, setWide] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth >= breakpoint : false,
  );
  useEffect(() => {
    const handler = () => setWide(window.innerWidth >= breakpoint);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, [breakpoint]);
  return wide;
}
